// executors.provider.tsx

import React, { createContext, useContext } from 'react';

import { useIndex } from '../hooks';
import { NewWillContext } from '../pages/new-will/new-will-provider';

export const ExecutorsContext = createContext(null);

export function ExecutorsProvider({ children }) {
  const { will } = useContext(NewWillContext);
  const { data, loading } = useIndex('executors', { will_id: will.id });

  if (loading) {
    return (
      <div>Loading executors...</div>
    );
  }
  
  return (
    <ExecutorsContext.Provider value={{ executors: data || [] }}>
      {children}
    </ExecutorsContext.Provider>
  );
}

